import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { authService } from '../../../services/authService';
import classes from './socialLoginButton.module.css';
import { socialAuth } from '../../../store/actions/auth';
import PromptMessage from '../../containers/promptMessage/promptMessage';

const SocialLoginButton = ({ provider, icon, alt, onSocialAuth }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  // Cleanup function to prevent memory leaks
  useEffect(() => {
    return () => {
      setLoading(false);
      setError(null);
      setShowPrompt(false);
    };
  }, []);

  const handleSocialLogin = async () => {
    // Prevent multiple clicks
    if (loading) return;

    try {
      setLoading(true);
      setError(null);
      setShowPrompt(false);
      
      const result = await authService.socialLogin(provider);
      if (result.user) {
        const idToken = await result.user.getIdToken();
        onSocialAuth(provider, idToken);
      }
    } catch (error) {
      console.error('Social login error:', error);
      
      // Don't show error for user-cancelled popup
      if (error.code !== 'auth/popup-closed-by-user') {
        setError(error.message);
        setShowPrompt(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button 
        className={`${classes.SocialLoginButton} ${loading ? classes.Loading : ''}`}
        onClick={handleSocialLogin}
        disabled={loading}
      >
        {loading ? (
          <div className={classes.Spinner} />
        ) : (
          <img src={icon} alt={alt} className={classes.SocialIcon} />
        )}
      </button>
      
      {error && showPrompt && (
        <PromptMessage 
          message={error} 
          status='ERROR' 
          button='CLOSE' 
          click={() => setShowPrompt(false)} 
        />
      )}
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  onSocialAuth: (provider, token) => dispatch(socialAuth(provider, token))
});

export default connect(null, mapDispatchToProps)(SocialLoginButton);